module.exports = __webpack_public_path__ + "static/media/React.js_logo.3d593052.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Footer/React.js_logo.svg
 ** module id = 178
 ** module chunks = 0
 **/